<input class="form-control"
       [formControl]="input" [maxlength]="maxLength()"
       [required]="true" [placeholder]="'e.g. 100'" style="resize: none"/>
<div class="invalid-feedback">Gross weight is required</div>
